module.exports = __webpack_public_path__ + "img/none.30183abd.png";